const Patrol = `{
  approvedId
  displayName
  senderId
  updatedAt
  startCoordinates {
    lat
    lng
  }
  endCoordinates {
    lat
    lng
  }
  notes
  startTime
  endTime
  propertyId
  serviceProviderId
  patrolId
  sendAlert
  isVacationWatch
  isCardinal
  formattedAddress
  attachedMedia {
    mediaId
    description
    createdAt
  }
  processed
}`;

export default Patrol;
